import { GeneralService } from './../../../services/general.service';
import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { ToastrService } from "ngx-toastr";
import { MustMatch, PASSWORD_PATTERN, VALIDEMAILREGEX } from "src/app/helpers/helperResources";
import { SignupLoginService } from "src/app/services/signupLogin.service";
import { AuthService } from "../../auth.service";

@Component({
  selector: "app-complete-signup",
  templateUrl: "./complete-signup.component.html",
  styleUrls: ["./complete-signup.component.css"],
})
export class CompleteSignupComponent implements OnInit {
  isLoading: boolean = false;
  setView: string;
  spinnerType: string;
  setSpinnerStatus: string;
  showSpinner: boolean = true;
  completeSignUpForm: FormGroup;
  validEmailRegex: any;
  getUser: any;
  passwordPattern: string | RegExp;
  loader: any = {};
  showPassword = "password"
  confirmPassword = "password";
  license = {
    error:{
      message: 'Your sign-up process is complete. Please contact your administrator to assign you a license',
      status: false
    }
  }  

  constructor(
    private svc: SignupLoginService,
    private toastr: ToastrService,
    private gs: GeneralService,
    private authSrv: AuthService,
    private route: ActivatedRoute,
    private fb: FormBuilder,
    private router: Router
  ) {
    this.spinnerType = "jsBin";
    this.setSpinnerStatus = "...";
    this.validEmailRegex = VALIDEMAILREGEX; // email validation
    this.passwordPattern = PASSWORD_PATTERN
  }

  async ngOnInit() {
    this.createForm();
    const id = this.route.snapshot.params.id;
    await this.fetchUserDetails(id);
  }

  get f() {
    return this.completeSignUpForm.controls;
  }

  createForm() {
    this.completeSignUpForm = this.fb.group(
      {
        firstName: ["", Validators.required],
        lastName: ["", Validators.required],
        email: [
          "",
          Validators.compose([
            Validators.required,
            Validators.pattern(this.validEmailRegex),
          ]),
        ],
        password: [
          "",
          Validators.compose([
            Validators.required,
            Validators.minLength(8),
            Validators.pattern(this.passwordPattern),
          ]),
        ],
        confirmPassword: ["", Validators.required],
      },
      {
        validator: MustMatch("password", "confirmPassword"),
      }
    );
  }

  async fetchUserDetails(id) {
    try {
      let payload;
      this.loader.user = true;
      await this.svc
        .getIncompleteUserDetails(id)
        .toPromise()
        .then((u) => {
          const item = {
            ...u["user"],
            ...u["userRel"],
          };
          payload = item;
        });
      this.getUser = payload;
      const { password } = payload;
      if (!payload.email || payload.email == null || payload.email == undefined)
        return (this.setView = "showFail");
      else if (payload.password) {
        this.confirmAccount(id);
        return;
      } else {
        await this.presetFormValues(payload);
        this.setView = "showEditForm";
      }
    } catch (error) {
      this.setView = "showFail";
    } finally {
      this.loader.user = false;
      this.showSpinner = false;
    }
  }

  async confirmAccount(id) {
    try {
      let data: any = await this.svc.verifyAccount(id).toPromise();
      this.setView = "showSuccess";
    } catch (error) {
      this.setView = "showFail";
    }
  }

  async presetFormValues(payload) {

    this.completeSignUpForm.patchValue({
      firstName: payload.firstName,
      lastName: payload.lastName,
      email: payload.email,
    });
  }

  //Submit form
  onSubmit() {
    this.processForm();
  }
  private successLoginAction(data) {
    if(data.userRel && data.userRel.assignedLicense !== null && data.userRel.assignedLicense === false){
      this.license.error.status = true;
      //this.toastr.error(this.license.error.message, this.license.error.status);
      return;
    }
    this.svc.successLoginActionSrv(data).subscribe((resp) => {
      this.authSrv.storeUser({ ...data, ...resp});
      this.gs.fetchCurrency.next("");
      this.router.navigate(["/dashboard"]);
    }, err => {
      this.toastr.error(err.error.message, err.error.status);
    })
  }

  togglePasswordVisibility() {
    this.showPassword = (this.showPassword === "password") ? "text" : "password"
  }

  toggleCpPasswordVisibility() {
    this.confirmPassword = (this.confirmPassword === "password") ? "text" : "password"
  }


  processForm() {
    this.isLoading = true;
    let payload = {
      ...this.completeSignUpForm.value,
      agent: this.getUser.agent,
      email: this.getUser.email,
      salesPerson: this.getUser.salesPerson,
      userID: this.getUser.userID,
      orgID: this.getUser.orgID,
      roleName: this.getUser.roleName,
    };

    this.svc.completeUserSignup(payload).subscribe((res: any) => {
      this.toastr.success(res.message, res.status);
      this.successLoginAction(res);
    }, (err) => {
      this.toastr.error(err.error.message, err.error.status);
    }).add(() => {
        setTimeout(() => (this.isLoading = false), 5000);
      });
  }
}
